<template>
  <div>
    <ButtonComponent
      id="request_otp_login"
      :variant="$props.variant"
      :text="buttonText[$props.type][$props.lang]"
      icon="Mail"
      @click="startValidation()"
      class="text-center"
    >
    </ButtonComponent>
    <b-modal id="modal-email-signin" @hide="close" size="md" header-bg-variant="dark" header-text-variant="light">
      <template #modal-title>
        <ShieldCheck :size="20" class="mr-2 text-white" />
        <span class="font-weight-bold text-white">{{ labels[$props.lang].modal_title }}</span>
      </template>
      <b-container v-if="step == 1" class="py-2">
        <b-row>
          <b-col md="12">
            <div class="mb-4 p-3 bg-light rounded text-muted small border-left border-info d-flex align-items-center" style="border-left-width: 4px !important;">
              <Info :size="30" class="mr-3 text-info" />
              <span v-html="labels[$props.lang].otp_explain"></span>
            </div>
            <div class="mb-2 font-weight-bold" style="font-size: 1.1rem; color: #333;">
              {{ labels[$props.lang].instruction_step1 }}
            </div>
            <b-form-input name="client"
                          v-model.trim="client"
                          @change="validateEmail"
                          @input="validateEmail();cleanSpace()"
                          :class="isEmailValid"
                          autocomplete="off"
                          :state="clientState"
                          :placeholder="labels[$props.lang].placeholder_step1"
                          :type="$props.channelType"
                          required
                          style="font-size: 1.25rem;"
            >
            </b-form-input>
            <small class="d-block mb-3" style="font-size: 11px;color:#aaaaaa;">{{ labels[$props.lang].help_step1 }}</small>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-if="step == 2">
        <InputOTP :digits="6"
                  :text="labels[$props.lang].instruction_step2"
                  @complete="validate"
        >
        </InputOTP>
      </b-container>
      <b-container class="text-center" v-if="step == 3">
        <b-spinner class="mr-2" variant="primary" label="Loading..."></b-spinner><br>
        <label class="text-muted"> {{ labels[$props.lang].process_step3 }}</label>
      </b-container>
      <b-container class="text-center" v-if="step == 4">
        <b-alert show variant="success">
          <strong>{{ labels[$props.lang].success_step4 }}</strong>
        </b-alert>
      </b-container>
      <b-container class="text-center" v-if="step == 5">
        <b-alert show variant="danger">
          <strong>{{ labels[$props.lang].fail_step5 }}</strong>
        </b-alert>
      </b-container>
      <!-- STEP 1 -->
      <template #modal-footer>
        <b-container class="text-right" v-if="step == 1">
          <ButtonComponent
              :text="labels[$props.lang].btn_send"
              @click="sendCode()"
              variant="success"
              icon="ArrowRight"
              icon-position="end"
              :disabled="!clientState"
          >
          </ButtonComponent>
        </b-container>
        <b-container class="text-right" v-if="step == 2">
          <ButtonComponent
              :text="labels[$props.lang].btn_validate"
              @click="validate()"
              variant="primary"
              icon="ShieldCheck"
              icon-position="start"
          >
          </ButtonComponent>
        </b-container>
        <b-container class="text-center" v-if="step >= 4">
          <ButtonComponent
              :text="labels[$props.lang].btn_close"
              @click="close"
              variant="secondary"
              icon="X"
              icon-position="start"
          >
          </ButtonComponent>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ShieldCheck, Info } from '@lucide/vue'
import ButtonComponent from './ButtonComponent.vue'
import InputOTP from '../../components/input/InputOTP.vue'
import axios from 'axios'
export default {
  name: 'ButtonEmailVerification',
  components: {
    InputOTP,
    ButtonComponent,
    ShieldCheck,
    Info
  },
  data () {
    return {
      step: 1,
      client: '',
      token: '',
      clientState: null,
      labels: {
        EN: {
          modal_title: 'Secure Verification with OTP',
          instruction_step1: 'Type your email to continue.',
          placeholder_step1: 'Type your email',
          help_step1: 'We are going to send an email with a 6-digits code to access your account.',
          otp_explain: '<b>What is OTP?</b> One-Time Password (OTP) is a secure code sent to your email to verify it\'s really you.',
          instruction_step2: 'We sent a <b>code to your email</b> to verificate your identity.',
          process_step3: 'Code verification process ...',
          success_step4: 'Success! Your email has been verified.',
          fail_step5: 'Fail! Your email couldn\'t be verified.',
          btn_send: 'Send Code',
          btn_validate: 'Validate Email',
          btn_close: 'Close'
        },
        ES: {
          modal_title: 'Verificación Segura con OTP',
          instruction_step1: 'Escribe tu correo para continuar.',
          placeholder_step1: 'Escribe tu correo',
          help_step1: 'Enviaremos un correo con un código de 6 dígitos para acceder a tu cuenta.',
          otp_explain: '<b>¿Qué es OTP?</b> La Contraseña de un Solo Uso (OTP) es un código de seguridad que enviamos a tu correo para verificar tu identidad.',
          instruction_step2: 'Hemos enviado un <b>código a tu correo</b> para verificar tu identidad.',
          process_step3: 'Proceso de verificación de código ...',
          success_step4: '¡Éxito! Tu correo ha sido verificado.',
          fail_step5: '¡Error! Tu correo no pudo ser verificado.',
          btn_send: 'Enviar Código',
          btn_validate: 'Validar Email',
          btn_close: 'Cerrar'
        },
        PT: {
          modal_title: 'Verificação Segura',
          instruction_step1: 'Digite seu e-mail para abrir sua conta.',
          placeholder_step1: 'Digite seu e-mail',
          help_step1: 'Enviaremos um e-mail com um código de 6 dígitos para acessar sua conta.',
          otp_explain: '<b>O que é OTP?</b> A Senha de Uso Único (OTP) é um código de segurança enviado ao seu e-mail para verificar sua identidade.',
          instruction_step2: 'Enviamos um <b>código para seu e-mail</b> para verificar sua identidade.',
          process_step3: 'Processo de verificação de código...',
          success_step4: 'Sucesso! Seu e-mail foi verificado.',
          fail_step5: 'Falha! Seu e-mail não pôde ser verificado.',
          btn_send: 'Enviar código',
          btn_validate: 'Validar e-mail',
          btn_close: 'Fechar'
        },
        FR: {
          modal_title: 'Vérification Sécurisée',
          instruction_step1: 'Tapez votre e-mail pour ouvrir votre compte.',
          placeholder_step1: 'Tapez votre e-mail',
          help_step1: 'Nous allons envoyer un e-mail avec un code à 6 chiffres pour accéder à votre compte.',
          otp_explain: '<b>Qu\'est-ce que l\'OTP ?</b> Le mot de passe à usage unique (OTP) est un code de sécurité envoyé à votre e-mail pour vérifier votre identité.',
          instruction_step2: 'Nous avons envoyé un <b>code à votre e-mail</b> pour vérifier votre identité.',
          process_step3: 'Processus de vérification du code...',
          success_step4: 'Succès ! Votre e-mail a été vérifié.',
          fail_step5: 'Échec ! Votre e-mail n\'a pas pu être vérifié.',
          btn_send: 'Envoyer le code',
          btn_validate: 'Valider l\'e-mail',
          btn_close: 'Fermer'
        }
      },
      buttonText: {
        LOGIN: {
          EN: 'Sign in <b>with your Email</b>',
          ES: 'Iniciar <b>con tu Email</b>',
          PT: 'Entrar <b>com seu e-mail</b>',
          FR: 'Se connecter <b>avec votre e-mail</b>'
        },
        SIGNUP: {
          EN: 'Sign up <b>with your Email</b>',
          ES: 'Regístrate <b>con tu Email</b>',
          PT: 'Cadastrar-se <b>com seu e-mail</b>',
          FR: 'S\'inscrire <b>avec votre e-mail</b>'
        }
      }
    }
  },
  props: {
    variant: String,
    channel: Number,
    lang: {
      type: String,
      default: 'EN'
    },
    type: {
      type: String,
      default: 'LOGIN'
    },
    channelType: {
      type: String,
      default: 'EMAIL'
    }
  },
  methods: {
    validateEmail () {
      // CLEAN SPACE
      this.cleanSpace()
      // VALIDATE EMAIL
      const emailCheck = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
      if (emailCheck.test(this.client)) {
        this.clientState = true
      } else {
        this.clientState = false
      }
    },
    cleanSpace () {
      this.client = this.client.replace(/^\s+|\s+$/gm, '')
    },
    // METHOD TO VALIDATE EMAIL
    async sendCode () {
      this.step = 2
      const backendUrl = process.env.VUE_APP_BACKEND_URL || '/api'
      // DATA
      const datos = {
        client: this.client,
        channel: this.channel
      }
      // CALL AXIOS AND SEND JSON
      await axios.post(`${backendUrl}/login/otp/send`, datos).then(response => {
        const res = response.data
        this.token = res.DATA.TOKEN
      })
    },
    async validate (code) {
      this.step = 3
      const backendUrl = process.env.VUE_APP_BACKEND_URL || '/api'
      const datos = {
        client: this.client,
        channel: this.channel,
        token: this.token,
        code: code
      }
      // VALIDATE THE CODE TO COMPLETE THE LOGIN
      await axios.post(`${backendUrl}/login/otp/validate`, datos).then(response => {
        const res = response.data
        if (Number(res.CODE) === 1 && res.DATA && res.DATA.TOKEN) {
          this.step = 4
          // Guardar información del usuario si es necesario (similar a lo que hace Redirect.get_html_response)
          const userInfo = {
            token: res.DATA.TOKEN,
            user: res.DATA.USER
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo))

          this.$bvModal.hide('modal-email-signin')
          // Redirigir a la URL proporcionada por el servidor
          window.location.href = res.DATA.REDIRECT_URL || '/redirect/'
        } else {
          this.step = 5
          setTimeout(() => {
            this.step = 1
          }, 500)
        }
      })
      // SUCCESS THE LOGIN
      // this.$bvModal.hide('modal-email-signin')
    },
    startValidation () {
      this.$bvModal.show('modal-email-signin')
    },
    close () {
      this.clientState = null
      this.step = 1
      this.client = ''
      this.$bvModal.hide('modal-email-signin')
    },
    isEmailValid: function () {
      return (this.email === '') ? '' : (this.reg.test(this.email)) ? 'has-success' : 'has-error'
    }
  }
}
</script>
<style lang="scss" scoped>
  @use "../../assets/styles/variables.scss" as *;
  ::v-deep .modal-dialog {
    margin-top: 0 !important;
  }
  ::v-deep .modal-content {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
    border: none !important;
  }
  ::v-deep .modal-header {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
</style>
